var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.config
    ? _c(
        "div",
        {
          class: { mobile: _vm.mobile, notNumber: _vm.notNumber },
          attrs: { id: "autocomplete-component" }
        },
        [
          _c("div", { staticClass: "autocomplete-address rds-mb-l03" }, [
            _c("div", { staticClass: "rds-input__cnt" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.searchTerm,
                    expression: "searchTerm"
                  }
                ],
                ref: "autocompleteInput",
                staticClass: "rds-input",
                attrs: { placeholder: _vm.config.placeholder, type: "text" },
                domProps: { value: _vm.searchTerm },
                on: {
                  input: [
                    function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.searchTerm = $event.target.value
                    },
                    function($event) {
                      _vm.searchTerm = $event.target.value
                    },
                    _vm.getItems
                  ],
                  keydown: [
                    _vm.getItems,
                    function($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "down", 40, $event.key, [
                          "Down",
                          "ArrowDown"
                        ])
                      ) {
                        return null
                      }
                      return _vm.onArrowDown($event)
                    },
                    function($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "up", 38, $event.key, [
                          "Up",
                          "ArrowUp"
                        ])
                      ) {
                        return null
                      }
                      return _vm.onArrowUp($event)
                    },
                    function($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                      ) {
                        return null
                      }
                      return _vm.onEnter($event)
                    }
                  ]
                }
              }),
              _vm._v(" "),
              _vm.searchTerm
                ? _c("span", {
                    staticClass:
                      "autocomplete-close rds-input__icon rds-icon-Close",
                    attrs: { "aria-hidden": "true" },
                    on: { click: _vm.clearItem }
                  })
                : _c("span", {
                    staticClass: "rds-input__icon rds-icon-Search",
                    attrs: { "aria-hidden": "true" }
                  }),
              _vm._v(" "),
              _vm.isOpen
                ? _c(
                    "ul",
                    { staticClass: "autocomplete-results rds-dropdown" },
                    [
                      _vm.noResults
                        ? _c(
                            "li",
                            {
                              staticClass: "autocomplete-no-result",
                              attrs: { disabled: "" }
                            },
                            [_vm._v(_vm._s(_vm.config.noResults))]
                          )
                        : _vm._l(_vm.mappedItems, function(item, i) {
                            return _c("li", {
                              key: i,
                              staticClass: "autocomplete-result",
                              class: { "is-active": i === _vm.arrowCounter },
                              domProps: {
                                innerHTML: _vm._s(item.autocompleteContent)
                              },
                              on: {
                                click: function($event) {
                                  return _vm.selectItem(item)
                                }
                              }
                            })
                          })
                    ],
                    2
                  )
                : _vm._e()
            ])
          ]),
          _vm._v(" "),
          _vm.notNumber
            ? _c("div", { staticClass: "autocomplete-number rds-mb-l03" }, [
                _c("div", { staticClass: "rds-input__cnt" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.streetNumber,
                        expression: "streetNumber"
                      }
                    ],
                    staticClass: "rds-input",
                    attrs: {
                      placeholder: _vm.config.numberPlaceHolder,
                      type: "text"
                    },
                    domProps: { value: _vm.streetNumber },
                    on: {
                      input: [
                        function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.streetNumber = $event.target.value
                        },
                        function($event) {
                          _vm.streetNumber = $event.target.value
                        },
                        _vm.searchWithNumber
                      ]
                    }
                  }),
                  _vm._v(" "),
                  _vm.streetNumber
                    ? _c("span", {
                        staticClass:
                          "autocomplete-close rds-input__icon rds-icon-Close",
                        attrs: { "aria-hidden": "true" },
                        on: { click: _vm.clearNumber }
                      })
                    : _vm._e()
                ])
              ])
            : _vm._e()
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-43c2d001", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-43c2d001","hasScoped":false,"transformToRequire":{"video":["demo","poster"],"source":"demo","img":"demo","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./autocomplete-component/src/AutocompleteComponent.vue
// module id = null
// module chunks = 